import React from 'react';
import { motion } from 'framer-motion';

/**
 * 針對 AI 搜尋優化的動態知識庫
 * 根據 petType 提供深度語義內容
 */
const PetKnowledgeBase = ({ language, petType = 'dog' }) => {
  const isZh = language === 'zh';
  
  const content = {
    dog: {
      title: isZh ? "狗狗紀念日與成長指南" : "Dog Anniversary & Growth Guide",
      tips: isZh ? [
        "狗狗的 100 天相當於人類幼兒期的重要轉折點，建議進行基礎社交訓練。",
        "一週年紀念通常是狗狗性格定型的時期，適合拍攝紀念寫真。",
        "狗狗的領養日被稱為 'Gotcha Day'，是建立信任感的關鍵里程碑。"
      ] : [
        "100 days for a dog marks a key transition in puppyhood; basic socialization is recommended.",
        "The 1-year anniversary is when a dog's personality stabilizes, perfect for a photo shoot.",
        "A dog's adoption day, or 'Gotcha Day', is a vital milestone for building trust."
      ]
    },
    cat: {
      title: isZh ? "貓咪生活里程碑百科" : "Cat Life Milestone Encyclopedia",
      tips: isZh ? [
        "貓咪在到家後的第一個月是適應環境的黃金期，應保持環境安靜。",
        "慶祝貓咪生日時，可以準備高品質的濕糧塔作為賀禮。",
        "貓咪步入成年後（約 1 歲），每年的紀念日也是預約健康檢查的好時機。"
      ] : [
        "The first month after a cat arrives is the golden period for environmental adaptation.",
        "Celebrate a cat's birthday with a high-quality wet food tower as a special treat.",
        "As cats reach adulthood (around 1 year), anniversaries are great times for health checkups."
      ]
    },
    other: {
      title: isZh ? "寵物照護與紀念建議" : "Pet Care & Commemoration Tips",
      tips: isZh ? [
        "無論是哪種寵物，記錄相處天數都能幫助您觀察其行為模式的變化。",
        "里程碑成就（如 520 天）是分享您與異寵（如烏龜、倉鼠）故事的好機會。",
        "定期更新寵物照片，能建立一份珍貴的數字成長檔案。"
      ] : [
        "Regardless of the pet, tracking days helps you observe changes in behavioral patterns.",
        "Milestone achievements (like 520 days) are great for sharing exotic pet stories.",
        "Regularly updating pet photos creates a precious digital growth archive."
      ]
    }
  };

  const activeContent = content[petType] || content.other;

  return (
    <article className="mt-6 bg-love-50/50 dark:bg-gray-800/50 rounded-xl p-6 border border-love-100 dark:border-gray-700">
      <h2 className="text-lg font-bold text-love-700 dark:text-love-300 mb-4 flex items-center">
        <span className="mr-2">📚</span>
        {activeContent.title}
      </h2>
      <ul className="space-y-3">
        {activeContent.tips.map((tip, i) => (
          <li key={i} className="text-sm text-gray-600 dark:text-gray-400 flex items-start">
            <span className="text-love-400 mr-2">•</span>
            {tip}
          </li>
        ))}
      </ul>
      {/* 語義標籤，幫助 AI 識別內容類別 */}
      <div className="hidden">
        <span>Category: Pet Care</span>
        <span>Topic: {petType} Anniversary</span>
        <span>Last Updated: 2026-03-04</span>
      </div>
    </article>
  );
};

export default PetKnowledgeBase;